import React, {useEffect, useRef, useState} from 'react';
import SelectorPicker from './SelectorPicker';
import TimePicker from './TimePicker';
import MultiPicker from './MultiPicker';
import {LabelWidget} from "../../index";
import DateTimerPicker from "./DateTimerPicker";

const TPickerWidget = (props:any) => {
  const { mode, value:wValue, isVisible, updateWidgetProperty,
    label,
    fontSize,
    color,
    fontStyle,
    inputFontSize,
    inputColor,
    inputFontStyle,
    bgColor,
    borderColor,
    labelPosition,
    labelAlignment,
    isRequired,
    borderBottomColor,
    borderBottomWidth,
    labelWidth,
    placeholderAlignment
  } = props;
  const isInitialRender = useRef(true);
  const [value, setValue] = useState<string>('');
  const onDateChange = (v:any)=>{
    setValue(v);
    updateWidgetProperty&&updateWidgetProperty(v);
  };

  useEffect(()=>{
    setValue(wValue);
  }, [wValue]);

  useEffect(()=>{
    //初始化时不处理
    if (isInitialRender.current) {
      isInitialRender.current = false;
    }else{
      setValue('');
    }
  }, [mode]);

  return (
    <LabelWidget
      className="at-picker-wrapper"
      label={label}
      fontSize={fontSize}
      color={color}
      fontStyle={fontStyle}
      inputFontSize={inputFontSize}
      inputColor={inputColor}
      inputFontStyle={inputFontStyle}
      bgColor={bgColor}
      borderColor={borderColor}
      labelAlignment={labelAlignment}
      labelPosition={labelPosition}
      required={isRequired}
      borderBottomColor={borderBottomColor}
      borderBottomWidth={borderBottomWidth}
      labelWidth={labelWidth}
      placeholderAlignment={placeholderAlignment}
    >
      {
        mode === 'date'&& <DateTimerPicker {...props} value={value} onDateChange={onDateChange} />
      }
      {
        mode === 'selector'&& <SelectorPicker {...props} value={value} onDateChange={onDateChange} />
      }
      {
        mode === 'time'&& <TimePicker {...props} value={value} onDateChange={onDateChange} />
      }
      {
        mode === 'multiSelector'&& <MultiPicker {...props} value={value} onDateChange={onDateChange} />
      }
    </LabelWidget>
  );
};

export default TPickerWidget;
